import {
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CForm,
  CFormInput,
  CFormLabel,
  CFormTextarea,
  CRow,
} from "@coreui/react";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { pickupDoneByCustomer } from "src/api/commonapi";
import { Routes } from "src/constants/api_url";
import { notification } from "src/constants/message";
import moment from "moment";
import { fetchSetting } from "src/api/common";
import CustomImage from "src/views/CommonFunctions/CustomImage";

const PickupOutDoneForm = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const code = queryParams.get("code");
  // console.log(code, "code");
  const defaultPickupDoneData = {
    p_i_note: "",
    p_d_date: moment().format("DD-MM-YYYY"),
  };
  const [pickupDoneData, setPickupDoneData] = useState(defaultPickupDoneData);
  const [submitResponse, setSubmitResponse] = useState(0);
  const [signature, setSignature] = useState("");
  const [step, setStep] = useState(0);
  const [c_url, setC_url] = useState({});

  useEffect(async () => {
    const resp = await fetchSetting();
    setC_url(resp?.c_url);
  }, []);

  const pickupSendingBySelfFunction = async () => {
    let fdata = new FormData();
    if (pickupDoneData.p_d_date == undefined || pickupDoneData.p_d_date == "") {
      let notify = notification({
        type: "error",
        message: "Please Select Courier Company",
      });
      notify();
    } else {
      setStep(1);
      Object.keys(pickupDoneData)?.map((key) => {
        fdata.append(key, pickupDoneData[key]);
      });
      const plain = Buffer.from(code, "base64").toString("utf8");
      fdata.append("sending_user", 1);
      fdata.append("lead_id", parseInt(plain?.split("_")[0]));
      const resp = await pickupDoneByCustomer(fdata);
      let notify = notification({
        type: resp.status == 0 ? "error" : "success",
        message: resp.message,
      });
      notify();
      if (resp.status == 0 || resp.status == 2) {
        setStep(0);
      }
      if (resp.status == 1) {
        setSignature(resp?.data);
        setSubmitResponse(1);
        setStep(0);
        setPickupDoneData(defaultPickupDoneData);
        setTimeout(() => {
          if (c_url != undefined && c_url != null && c_url != "") {
            window.location.replace(`${c_url}`);
          }
        }, 5000);
      }
    }
  };

  return (
    <>
      <div className="d-flex flex-row">
        <CContainer>
          {submitResponse == 0 ? (
            <>
              <div className="center-hor-ver">
                <div className="form-container-cus bg-white my-5">
                  <CRow>
                    <CCol md={12} className="text-center m-1">
                      <CustomImage
                        src={`${Routes.API_HOSTNAME}/images/adminlogo/loginlogo.png`}
                        className="cus_form_logo"
                      />
                      <h5
                        className="form_title text-center"
                        style={{ color: "black" }}
                      >
                        The form for Confirmation that the Pick up has been
                        Done.
                      </h5>
                    </CCol>
                    <CCol>
                      <CForm>
                        <div className="mb-3">
                          <CFormLabel className="" style={{ color: "black" }}>
                            Pickup Done Date
                          </CFormLabel>
                          <CFormInput
                            value={moment(
                              pickupDoneData?.p_d_date,
                              "DD-MM-YYYY"
                            ).format("YYYY-MM-DD")}
                            type="date"
                            id="p_i_date"
                            name="p_i_date"
                            onChange={(e) => {
                              setPickupDoneData({
                                ...pickupDoneData,
                                p_d_date: moment(e.target.value).format(
                                  "DD-MM-YYYY"
                                ),
                              });
                            }}
                          />
                        </div>
                        <div className="mb-3">
                          <CFormLabel
                            className="mb-1"
                            style={{ color: "black" }}
                          >
                            If any Additional Instruction
                            <span> (Optional)</span> :
                          </CFormLabel>
                          <CFormTextarea
                            type="text"
                            id="p_i_note"
                            name="p_i_note"
                            placeholder="Enter Note"
                            value={pickupDoneData?.p_i_note}
                            onChange={(e) => {
                              setPickupDoneData({
                                ...pickupDoneData,
                                p_i_note: e.target.value,
                              });
                            }}
                          />
                        </div>
                        <CCol className="mb-3" style={{ textAlign: "center" }}>
                          <CButton
                            disabled={step == 0 ? false : true}
                            color="primary"
                            onClick={() => {
                              pickupSendingBySelfFunction();
                            }}
                          >
                            Submit
                          </CButton>
                        </CCol>
                      </CForm>
                    </CCol>
                  </CRow>
                </div>
              </div>
            </>
          ) : (
            <>
              <CRow className="justify-content-center">
                <CCol md={5} style={{ width: "600px" }}>
                  <CCardGroup>
                    <CCard className="p-4">
                      <CCardBody>
                        <>
                          <CForm className="dsgrid">
                            <CustomImage
                              src={`${Routes.API_HOSTNAME}/images/adminlogo/check.png`}
                              className="mb-3 center_img"
                            />
                            <h5
                              className="text-center mb-3"
                              style={{ color: "#000" }}
                            >
                              We have noted the completion of the Pickup.
                            </h5>
                            <h5
                              className="text-center mb-3"
                              style={{ color: "#000" }}
                            >
                              We will update you as soon as the envelope is
                              delivered to our office.
                            </h5>
                            <h2
                              className="text-center mb-3"
                              style={{ color: "#000" }}
                            >
                              Thank You
                            </h2>
                            {signature != "" && (
                              <h5
                                className="text-center mb-3"
                                style={{ color: "#000" }}
                              >
                                {signature}
                              </h5>
                            )}
                          </CForm>
                        </>
                      </CCardBody>
                    </CCard>
                  </CCardGroup>
                </CCol>
              </CRow>
            </>
          )}
        </CContainer>
      </div>
    </>
  );
};

export default PickupOutDoneForm;
